export default "__VITE_ASSET__Bpf1uQ_Z__"